import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../index.css"

import { TabPanel, TabView } from "primereact/tabview";

import GRNHistory from "./grnHistory";
import GRNTable from "./grnTable";

import Loading from "../../../../common/Loading"

import { insertSellerGRNQCPunch } from "../../../../services/api/sellerGRNQCPunch";
import { getSellerPOBySellerPOId } from "../../../../services/api/sellerPO";
import { getAdjustmentNotesBySellerPIPunchIds, insertDebitNote } from "../../../../services/api/adjustmentNotes";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../../../services/api/buyerReqItem";
import { getMaterialMasterAndTempMaterialIds } from "../../../../services/api/materialMaster";
import { getBuyerRequirementsById } from "../../../../services/api/buyerReq";
import { getApprovalInstancesByDocNos } from "../../../../services/api/approvalInstances";
import { Button, TextInputField } from '../../../../helpers'
import { Checkbox } from "primereact/checkbox";

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { fetchOrderTypesData } from "../../../../services/redux/reducers/commonThunk";

import { round } from "../../../../utils";
import { getCompanyById } from "../../../../services/api/company";


const GRN = (props) => {

    const { handleSellerGRNQCPunchRefresh } = props

    const [confirmDialogVisible, setConfirmDialogVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [selectedSellerPO, setSelectedSellerPO] = useState([])

    const [buyerReq, setBuyerReq] = useState({})
    const [sellerPO, setSellerPO] = useState([])
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [sellerPIPunchItems, setSellerPIPunchItems] = useState([])
    const [sellerGRNQCPunch, setSellerGRNQCPunch] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [adjustmentNote, setAdjustmentNote] = useState([])
    const [adjustmentNoteItems, setAdjustmentNoteItems] = useState([])
    const [approvalInstances, setApprovalInstances] = useState([])
    const [selectedPIPunchIds, setSelectedPIPunchIds] = useState([])
    const [currentGRN, setCurrentGRN] = useState("");
    const [currentAccepted, setCurrentAccepted] = useState("");
    const [sellerCompany, setSellerCompany] = useState(null)

    const [sellerBillAddrDetails, setSellerBillAddrDetails] = useState({})
    
    const dispatch = useDispatch()

    const usersData = useSelector(state => state.userDetails)
    const orderTypes = useSelector(state => state.common.orderTypes)

    const pmBranches = usersData.PMCompanyDetails?.companyPmBranches ? usersData.PMCompanyDetails.companyPmBranches : []
    
    useEffect(() => {
        setSelectedSellerPO(props.selectedSellerPO)
    },[])

    useEffect(() => {
        getSellerPO()
    },[selectedSellerPO])

    useEffect(() => {
        dispatch(fetchOrderTypesData())
    },[])

    const getSellerPO = async () => {
        setIsLoading(true)
        if (selectedSellerPO?.data?.sellerPOId){
            const response = await getSellerPOBySellerPOId(selectedSellerPO?.data?.sellerPOId, true)
            if (response.failure){
                dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Seller PIs not fetched', life: 3000}))
            } else {
                const newSellerPO = response?.data?.sellerPO
                const newSellerPOItems = response?.data?.sellerPOItems
                const newSellerPIPunch = response?.data?.sellerPIPunch
                const newSellerPIPunchItems = response?.data?.sellerPIPunchItems
                const newSellerGRNQCPunch = response?.data?.sellerGRNQCPunch
            
                const sellerCompanyRes = await getCompanyById(newSellerPO.companyId)
                if (sellerCompanyRes.failure){
                    return dispatch(raiseToast({severity:'error', detail: sellerCompanyRes.data.error, summary:'Seller Company', life: 3000}))
                }
                setSellerCompany(sellerCompanyRes.data)

                let updatedSellerGRNQCPunch = newSellerGRNQCPunch?.filter(eachSellerGRNPunch => eachSellerGRNPunch?.statusId === 1)

                const updatedSellerPIPunch = newSellerPIPunch?.map(eachSellerPIPunch => {
                    const relatedSellerPIPunchItems = newSellerPIPunchItems.filter(eachSellerPIPunchItem => eachSellerPIPunchItem?.sellerPIPunchId === eachSellerPIPunch?.sellerPIPunchId)
                    const relatedSellerGRNQCPunch = updatedSellerGRNQCPunch.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId)
                    let allProcessed = relatedSellerPIPunchItems.every(eachSellerPIPunchItem => {
                        const relatedSellerGRNQcPunches = relatedSellerGRNQCPunch?.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchItemId === eachSellerPIPunchItem.sellerPIPunchItemId)
                        relatedSellerGRNQcPunches?.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId)
                        return relatedSellerGRNQcPunches[0]?.acceptedQuantity + relatedSellerGRNQcPunches[0]?.rejectedQuantity + relatedSellerGRNQcPunches[0]?.shortQuantity === eachSellerPIPunchItem.qty
                    })
                    return {...eachSellerPIPunch, allProcessed : allProcessed, isProcessed : allProcessed, isHistoryVisible : false}
                })?.sort((a, b) => a.sellerPIPunchId - b.sellerPIPunchId)

                let sellerPIPunchIds = []
                newSellerPIPunch?.map(eachSellerPIPunch => sellerPIPunchIds?.push(eachSellerPIPunch?.sellerPIPunchId))

                let sellerPIPunchData = { sellerPIPunchIds : sellerPIPunchIds }
                const adjustmentNoteRes = await getAdjustmentNotesBySellerPIPunchIds(sellerPIPunchData)
                
                if (adjustmentNoteRes?.failure){
                    dispatch(raiseToast({severity:'error', detail: adjustmentNoteRes.data.error, summary:'Adjustment Notes Not Fetched.', life: 3000}))
                }else {
                    setAdjustmentNote(adjustmentNoteRes?.data?.adjustmentNote)
                    setAdjustmentNoteItems(adjustmentNoteRes?.data?.adjustmentNoteItems)
                }  


                setSellerBillAddrDetails(response.data.sellerBillAddrDetails)

                let buyerReqItemIds = []
                let materialIds = []
                newSellerPOItems?.map(eachSellerPOItem => buyerReqItemIds.push(eachSellerPOItem?.buyerReqItemId))
                newSellerPOItems?.map(eachSellerPOItem => materialIds.push(eachSellerPOItem?.materialId))

                let data = { buyerReqItemsIds : buyerReqItemIds }
                let materialDetailsRes = null
                if (newSellerPO?.expenseCategoryId){
                    materialDetailsRes = await getMaterialMasterAndTempMaterialIds({materialIds: materialIds})
                }else{
                    materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds(data)
                }
               
                if (materialDetailsRes.failure){
                    dispatch(raiseToast({severity:'error', detail: materialDetailsRes.data.error, summary:'Material Details Not Fetched.', life: 3000}))
                }else {
                    setMaterialDetails(materialDetailsRes?.data)
                }    

                if (!newSellerPO?.expenseCategoryId){
                    const buyerReqRes = await getBuyerRequirementsById(newSellerPO?.buyerReqId)

                    if (buyerReqRes.failure){
                        dispatch(raiseToast({severity:'error', detail: buyerReqRes.data.error, summary:'Buyer Requirement Not Fetched.', life: 3000}))
                    }else {
                        setBuyerReq(buyerReqRes?.data?.buyerRequirement)
                    }    
                }

                const relatedSellerPIPunchDocNos = newSellerPIPunch?.map(eachSellerPIPunch => eachSellerPIPunch?.docNo)

                const approvalInstancesRes = await getApprovalInstancesByDocNos({docNos: relatedSellerPIPunchDocNos})
                if (approvalInstancesRes?.failure){
                    dispatch(raiseToast({severity:'error', detail: approvalInstancesRes.data.error, summary:'Approval Instances Not Fetched', life: 3000}))
                }else{
                    setApprovalInstances(approvalInstancesRes?.data)
                }

                setSellerPO(newSellerPO)
                setSellerPOItems(newSellerPOItems)
                setSellerPIPunch(updatedSellerPIPunch)
                setSellerPIPunchItems(newSellerPIPunchItems)
                setSellerGRNQCPunch(updatedSellerGRNQCPunch)

                if(handleSellerGRNQCPunchRefresh){
                    handleSellerGRNQCPunchRefresh(updatedSellerGRNQCPunch)
                }
            }
        }
        setIsLoading(false)
    }

    const handleInputDateChange = (e) => {
        const updatedSellerPIPunchItems = sellerPIPunchItems?.map(eachSellerPIPunchItem => {
            return {...eachSellerPIPunchItem, [e.target.name] : e.target.value }
        })
        setSellerPIPunchItems(updatedSellerPIPunchItems)
    }

    const handleInputChange = (e, sellerPIPunchItemId, remainingQuantity) => {
        const updatedSellerPIPunchItems = sellerPIPunchItems?.map(eachSellerPIPunchItem => {
            if (eachSellerPIPunchItem.sellerPIPunchItemId === sellerPIPunchItemId){
                if (parseFloat(e.target.value) > parseFloat(remainingQuantity)){
                    dispatch(raiseToast({severity:'error', detail: `Available Qty : ${remainingQuantity} Only`, life: 3000}))
                    return {...eachSellerPIPunchItem, [e.target.name] : parseFloat(remainingQuantity)}
                } else {
                    return {...eachSellerPIPunchItem, [e.target.name] : e.target.value}
                }
                
            } else {
                return eachSellerPIPunchItem
            }
        })
        
        setSellerPIPunchItems(updatedSellerPIPunchItems)
    }

    const handleGRNClick = async ({emailObj, sellerPIPunchId, relatedSellerPIPunchItems, allProcessed, selectedPaymentMode, paymentMode, sdnRemarks}) => {
        console.log("selectedPaymentMode", selectedPaymentMode, paymentMode)
        const relatedSellerPIPunch = sellerPIPunch?.find(eachSellerPIPunch => eachSellerPIPunch?.sellerPIPunchId === sellerPIPunchId)
        const relatedSellerGRNQCPunch = sellerGRNQCPunch?.filter(eachSellerGRNPunch => eachSellerGRNPunch?.sellerPIPunchId === sellerPIPunchId)

        let data = {
            emailObj: emailObj,
            sellerPIPunchItems: relatedSellerPIPunchItems,
            sellerPIPunchId: sellerPIPunchId,
            sellerGRNQCPunch: relatedSellerGRNQCPunch,
            paymentMode: selectedPaymentMode
        }
        
        relatedSellerPIPunchItems = relatedSellerPIPunchItems?.filter(eachSellerPIPunchItem => eachSellerPIPunchItem?.processedDate)
        relatedSellerPIPunchItems = relatedSellerPIPunchItems?.filter(eachSellerPIPunchItem => eachSellerPIPunchItem?.receivedQuantity > 0 || eachSellerPIPunchItem?.rejectedQuantity > 0 || eachSellerPIPunchItem?.acceptedQuantity > 0 || eachSellerPIPunchItem?.shortQuantity > 0)
        if (relatedSellerPIPunchItems?.length > 0){
            const isCalculationsMisMatched = relatedSellerPIPunchItems?.some(eachSellerPIPunchItem => {
                return (eachSellerPIPunchItem?.receivedQuantity < eachSellerPIPunchItem?.acceptedQuantity + eachSellerPIPunchItem?.rejectedQuantity)
            })
            if (!isCalculationsMisMatched){
                setIsLoading(true)
                const response = await insertSellerGRNQCPunch(data)
                setIsLoading(false)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: 'Insert GRN', detail: response?.data?.error, life: 3000}))    
                }else {
                    dispatch(raiseToast({severity:'success', detail: "GRN is Done" , life: 3000}))

                    if (allProcessed){
                        const updatedSellerPIPunchItems = relatedSellerPIPunchItems?.filter(eachSellerPIPunchItem => eachSellerPIPunchItem?.rejectedQuantity || eachSellerPIPunchItem?.shortQuantity)
                        let totalAmountWithTax = 0
                        const updatedSellerPIPunchItemsData = updatedSellerPIPunchItems?.map(eachSellerPIPunchItem => {
                            const relatedSellerPOItem = sellerPOItems?.find(eachSellerPOItem => eachSellerPOItem?.sellerPOItemId === eachSellerPIPunchItem?.sellerPOItemId)
                            let itemAmountBeforeTax = (parseFloat(eachSellerPIPunchItem?.rejectedQuantity) + parseFloat(eachSellerPIPunchItem?.shortQuantity)) * relatedSellerPOItem?.unitPrice
                            let itemAmountWithTax = itemAmountBeforeTax + parseFloat(itemAmountBeforeTax * relatedSellerPOItem?.GSTRate * 0.01)
                            totalAmountWithTax += round(itemAmountWithTax)
                            return ({
                            sellerPIPunchItemId : eachSellerPIPunchItem?.sellerPIPunchItemId,
                            adjustedQty: parseFloat(eachSellerPIPunchItem?.rejectedQuantity) + parseFloat(eachSellerPIPunchItem?.shortQuantity),
                            adjustedPricePerUnit: relatedSellerPOItem?.unitPrice,
                            createdBy: usersData?.userId,
                        })
                        })
                        
                        if (updatedSellerPIPunchItems?.length > 0){
                            let logisticsGSTRate = sellerPO?.logisticsGSTRate
                            let logisticsWithTax = sellerPIPunch?.sellerPILogisticsTax
                            let logisticsBeforeTax = logisticsWithTax / (1 + logisticsGSTRate * 0.01)
                            let data = {
                                adjustmentNote : {
                                    sellerPIPunchId : sellerPIPunchId,
                                    adjustmentTypeId : 3,
                                    docNo: relatedSellerPIPunch?.docNo,
                                    fileNo: relatedSellerPIPunch?.fileNo,
                                    companyId: sellerPO?.companyId,
                                    branchId: sellerPO?.branchId,
                                    pmBranchId: sellerPO.pmBranchId,
                                    pmCompanyId: usersData.activeUserRoleDetails.pmCompanyId,
                                    adjustedLogisticsbeforeTax: logisticsBeforeTax,
                                    adjustedLogisticsGSTRate: logisticsGSTRate,
                                    adjustedLogisticsWithTax: sellerPO?.logisticsWithTax,
                                    adjustedOthersWithTax : sellerPO?.logisticsWithTax,
                                    createdBy: usersData?.userId,
                                    remarks: sdnRemarks,
                                    statusId: 7
                                },
                                adjustmentNoteItems : updatedSellerPIPunchItemsData
                            }
                            const debitNoteResponse = await insertDebitNote(data)
                            
                            if (debitNoteResponse.failure){
                                dispatch(raiseToast({severity:'error', summary: 'Debit Note', detail: "Debit Note is not Created" , life: 3000}))
                            }else {
                                dispatch(raiseToast({severity:'success', detail: "Debit Note is Created" , life: 3000}))
                            }
                        }
                    }
                    getSellerPO()
                }
                let updatedSellerPIPunchItems = sellerPIPunchItems?.map(eachSellerPIPunchItem => {
                    if (eachSellerPIPunchItem?.sellerPIPunchId === sellerPIPunchId){
                        return {...eachSellerPIPunchItem, "processedDate": ""}
                    }else{
                        return eachSellerPIPunchItem
                    }
                })
                setSellerPIPunchItems(updatedSellerPIPunchItems)
            }else{
                dispatch(raiseToast({severity:'warn', detail: 'Check the Quantities as it has Some mismatch ', life: 3000}))   
            }
        }else{
            dispatch(raiseToast({severity:'error', detail: 'Please Enter the Quantities.', life: 3000}))   
        }
    }

    const handleProcessedChange = (e, sellerPIPunchId) => {
        const updatedSellerPIPunch = sellerPIPunch?.map(eachSellerPIPunch => {
            if (eachSellerPIPunch.sellerPIPunchId === sellerPIPunchId){
                return {...eachSellerPIPunch, [e.target.name] : e.checked}
            } 
            return eachSellerPIPunch
        })
        
        setSellerPIPunch(updatedSellerPIPunch)
    }

    const handleViewClick = (sellerPIPunchId) => {
        const updatedSellerPIPunch = sellerPIPunch?.map(eachSellerPIPunch => {
            if (eachSellerPIPunch?.sellerPIPunchId === sellerPIPunchId){
                return {...eachSellerPIPunch, isHistoryVisible : !eachSellerPIPunch.isHistoryVisible}
            }
            return eachSellerPIPunch
        })
        
        setSellerPIPunch(updatedSellerPIPunch)
    }

    let isInvoiceEnableForPMBranch = false
    const relatedPMBranchDetail = pmBranches.find(eachBranch => eachBranch.branchId === sellerPO.pmBranchId)
    
    if(relatedPMBranchDetail?.isInvoicingEnabled){
        isInvoiceEnableForPMBranch = true
    }


    const handleSelectAllPIPunchIds = (e) => {
        if (e.target.checked) {
            const newSelectedIds = new Set(selectedPIPunchIds);
            sellerPIPunch.forEach(item => {
                if (item.statusId === 1 && !item.allProcessed) {
                    newSelectedIds.add(item.sellerPIPunchId);
                }
            });
            setSelectedPIPunchIds([...newSelectedIds]);
        } else {
            const remainingIds = selectedPIPunchIds.filter(id =>
                !sellerPIPunch.some(item => item.sellerPIPunchId === id && item.statusId === 1 && !item.allProcessed)
            );
            setSelectedPIPunchIds(remainingIds);
        }
    };
    
    const areAllPIPunchIdsSelected = () => {
        const allSelectableIds = sellerPIPunch
            .filter(item => item.statusId === 1 && !item.allProcessed)
            .map(item => item.sellerPIPunchId);
        return allSelectableIds.length > 0 && allSelectableIds.every(id => selectedPIPunchIds.includes(id));
    };    
    
    const handleSelect = (id, isSelected) => {
        setSelectedPIPunchIds(prevSelectedPIPunchIds => {
            if (isSelected) {
                if (!prevSelectedPIPunchIds.includes(id)) {
                    return [...prevSelectedPIPunchIds, id];
                }
                return prevSelectedPIPunchIds;
            } else {
                return prevSelectedPIPunchIds.filter(punchId => punchId !== id);
            }
        });
    };

    const handleApplyGRN = () => {
        const updatedSellerPIPunchItems = sellerPIPunchItems?.map(eachSellerPIPunchItem => {
            if (selectedPIPunchIds.includes(eachSellerPIPunchItem.sellerPIPunchId) && eachSellerPIPunchItem.statusId === 1) {
                const relatedSellerGRNQcPunches = sellerGRNQCPunch?.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchItemId === eachSellerPIPunchItem.sellerPIPunchItemId);
                relatedSellerGRNQcPunches?.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId);
                const remainingQuantity = relatedSellerGRNQcPunches[0] ? eachSellerPIPunchItem?.qty - relatedSellerGRNQcPunches[0]?.receivedQuantity - relatedSellerGRNQcPunches[0]?.shortQuantity : eachSellerPIPunchItem?.qty;
                let currentReceivableQuantity = remainingQuantity
                if (eachSellerPIPunchItem?.shortQuantity){
                    currentReceivableQuantity -= parseFloat(eachSellerPIPunchItem?.shortQuantity)
                }
                currentReceivableQuantity = round(currentReceivableQuantity)
                if(currentReceivableQuantity <= 0){
                    currentReceivableQuantity = 0
                }
                return { ...eachSellerPIPunchItem, receivedQuantity: currentReceivableQuantity }
            }
            return eachSellerPIPunchItem;
        });
        setSellerPIPunchItems(updatedSellerPIPunchItems);
    };
    
    const handleApplyAccepted = () => {
        if(currentAccepted){
            const selectedItems = sellerPIPunchItems.filter(item => selectedPIPunchIds.includes(item.sellerPIPunchId) && item.statusId === 1);
            const updatedSellerPIPunchItems = selectedItems.map(eachSellerPIPunchItem => {
                const relatedSellerGRNQcPunches = sellerGRNQCPunch?.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchItemId === eachSellerPIPunchItem.sellerPIPunchItemId);
                relatedSellerGRNQcPunches?.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId);
                const remainingQuantity = relatedSellerGRNQcPunches[0] ? eachSellerPIPunchItem?.qty - relatedSellerGRNQcPunches[0]?.receivedQuantity - relatedSellerGRNQcPunches[0]?.shortQuantity : eachSellerPIPunchItem?.qty;
                let currentReceivableQuantity = remainingQuantity
                let currentAcceptableQuantity = parseFloat(eachSellerPIPunchItem?.qty - remainingQuantity)
                if (eachSellerPIPunchItem?.receivedQuantity){
                    currentAcceptableQuantity += parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                }

                if (eachSellerPIPunchItem?.rejectedQuantity){
                    currentAcceptableQuantity -= parseFloat(eachSellerPIPunchItem?.rejectedQuantity)
                }
                if (eachSellerPIPunchItem?.shortQuantity){
                    currentReceivableQuantity -= parseFloat(eachSellerPIPunchItem?.shortQuantity)
                }
                if (relatedSellerGRNQcPunches[0]){
                    currentAcceptableQuantity = relatedSellerGRNQcPunches[0]?.receivedQuantity - relatedSellerGRNQcPunches[0]?.acceptedQuantity - relatedSellerGRNQcPunches[0]?.rejectedQuantity
                    if (eachSellerPIPunchItem?.receivedQuantity){
                        currentAcceptableQuantity += parseFloat(eachSellerPIPunchItem?.receivedQuantity)
                    }
                    if (eachSellerPIPunchItem?.rejectedQuantity){
                        currentAcceptableQuantity -= parseFloat(eachSellerPIPunchItem?.rejectedQuantity)
                    }
                }
                currentAcceptableQuantity = round(currentAcceptableQuantity)
                const newValue = Math.min(parseFloat(currentAcceptableQuantity), parseFloat(currentAccepted));
                return { ...eachSellerPIPunchItem, acceptedQuantity: newValue };
            });
            setSellerPIPunchItems(prevItems => prevItems.map(item =>
                updatedSellerPIPunchItems.find(updatedItem => updatedItem.sellerPIPunchItemId === item.sellerPIPunchItemId) || item
            ));
        }else{
            dispatch(raiseToast({severity:'error', detail: 'Please enter a value for Cur. Accepted', life: 3000}))  
        }
    };

    return (
        
            props?.isDisplayVisible ? (
                <TabView>
                    <TabPanel header="GRN & QC">
                        <div className="grn-tab">
                            <Loading visible={isLoading}/>
                            {(sellerPIPunch?.length === 0 && !isLoading) && <h5 className="text-center">Seller PI Punch haven't Done.</h5>}
                            {
                                sellerPIPunch?.map((eachSellerPIPunch, index) => {
                                    const relatedSellerGRNQCPunch = sellerGRNQCPunch.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId)
                                    const relatedAdjustmentNote = adjustmentNote?.filter(eachAdjustmentNote => eachAdjustmentNote?.sellerPIPunchId === eachSellerPIPunch?.sellerPIPunchId)
                                    return (
                                        <div className="p-card" key={`sellerPIPunch-${eachSellerPIPunch?.sellerPIPunchId}`}>
                                            <div>
                                                <GRNTable 
                                                    setIsLoading = {setIsLoading} 
                                                    isLoading = {isLoading} 
                                                    index={index}
                                                    adjustmentNote = {relatedAdjustmentNote} 
                                                    adjustmentNoteItems = {adjustmentNoteItems} 
                                                    buyerReq={buyerReq}
                                                    handleViewClick = {handleViewClick} 
                                                    getSellerPO = {getSellerPO} 
                                                    sellerPIPunchItems = {sellerPIPunchItems} 
                                                    materialDetails = {materialDetails} 
                                                    orderTypes={orderTypes}
                                                    sellerPO={sellerPO}
                                                    sellerPOItems={sellerPOItems}
                                                    sellerPIPunch = {eachSellerPIPunch} 
                                                    confirmDialogVisible = {confirmDialogVisible} 
                                                    setConfirmDialogVisible = {setConfirmDialogVisible} 
                                                    sellerGRNQCPunch = {sellerGRNQCPunch} 
                                                    handleGRNClick = {handleGRNClick} 
                                                    handleInputChange = {handleInputChange} 
                                                    handleInputDateChange = {handleInputDateChange} 
                                                    handleProcessedChange = {handleProcessedChange}
                                                    setSellerPIPunchItems={setSellerPIPunchItems}
                                                    isInvoiceEnableForPMBranch={isInvoiceEnableForPMBranch}
                                                    approvalInstances={approvalInstances}
                                                    handleSelect={handleSelect}
                                                    selectedPIPunchIds={selectedPIPunchIds}
                                                    sellerBillAddrDetails={sellerBillAddrDetails}
                                                    sellerCompany={sellerCompany}
                                                />
                                                {
                                                    eachSellerPIPunch?.isHistoryVisible && 
                                                        <div className="flex flex-column">
                                                            <GRNHistory sellerGRNQCPunch={relatedSellerGRNQCPunch} sellerPIPunchItems={sellerPIPunchItems} materialDetails={materialDetails}/>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </TabPanel>
                </TabView>
            ) : (
                <div className="grn-tab">
                    <Loading visible={isLoading}/>  
                    <div className='flex flex-row justify-content-start'>
                        <div className="flex flex-column mr-4 mt-3" >
                            <label style={{marginBottom:"5px", fontSize:"12px"}} >Select All</label>
                            <Checkbox 
                                checked={areAllPIPunchIdsSelected()} 
                                style={{ textAlign: "center" }} 
                                onChange={handleSelectAllPIPunchIds} 
                            />
                        </div>
                        <div className="flex flex-column mt-4">
                            <Button label="APPLY GRN" style={{backgroundColor:"#26a69a", height : "32px"}} onClick={handleApplyGRN} disabled={selectedPIPunchIds.length === 0} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4 lg:col-2 lg:mb-0 w-6rem">
                            <TextInputField name="currAccepted" labelText="Cur. Accepted" value={currentAccepted} onChange={(e) => setCurrentAccepted(e.target.value)} keyfilter="pnum" />  
                        </div>
                        <div className="flex flex-column lg:mb-0 md:col-4 lg:col-2 mt-3 w-6rem">
                            <Button label="APPLY" style={{backgroundColor:"#26a69a", height : "32px"}} onClick={handleApplyAccepted} disabled={selectedPIPunchIds.length === 0}/>
                        </div>
                    </div>
                    
                    {(sellerPIPunch?.length === 0 && !isLoading) && <h5 className="text-center">Seller PI Punch haven't Done.</h5>}
                    {
                        sellerPIPunch?.map((eachSellerPIPunch, index) => {
                            const relatedSellerGRNQCPunch = sellerGRNQCPunch.filter(eachGRNPunch => eachGRNPunch.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId)
                            const relatedAdjustmentNote = adjustmentNote?.filter(eachAdjustmentNote => eachAdjustmentNote?.sellerPIPunchId === eachSellerPIPunch?.sellerPIPunchId)
                            return (
                                <div className={`p-card py-2 ${eachSellerPIPunch?.statusId === 2 ? 'cancelled-watermark' : ''}`}>
                                    <div>
                                        <GRNTable 
                                            setIsLoading = {setIsLoading} 
                                            index={index}
                                            isLoading = {isLoading} 
                                            adjustmentNote = {relatedAdjustmentNote} 
                                            adjustmentNoteItems = {adjustmentNoteItems} 
                                            buyerReq={buyerReq}
                                            handleViewClick = {handleViewClick} 
                                            getSellerPO = {getSellerPO} 
                                            sellerPIPunchItems = {sellerPIPunchItems} 
                                            materialDetails = {materialDetails} 
                                            orderTypes={orderTypes}
                                            sellerPO={sellerPO}
                                            sellerPOItems={sellerPOItems}
                                            sellerPIPunch = {eachSellerPIPunch} 
                                            confirmDialogVisible = {confirmDialogVisible} 
                                            setConfirmDialogVisible = {setConfirmDialogVisible} 
                                            sellerGRNQCPunch = {sellerGRNQCPunch} 
                                            handleGRNClick = {handleGRNClick} 
                                            handleInputChange = {handleInputChange} 
                                            handleInputDateChange = {handleInputDateChange} 
                                            handleProcessedChange = {handleProcessedChange}
                                            setSellerPIPunchItems={setSellerPIPunchItems}    
                                            isInvoiceEnableForPMBranch={isInvoiceEnableForPMBranch}
                                            approvalInstances={approvalInstances}
                                            handleSelect={handleSelect}
                                            selectedPIPunchIds={selectedPIPunchIds}
                                            sellerBillAddrDetails={sellerBillAddrDetails}
                                            sellerCompany={sellerCompany}
                                        />
                                        {
                                            eachSellerPIPunch?.isHistoryVisible && 
                                                <div className="flex flex-column">
                                                    <GRNHistory sellerGRNQCPunch={relatedSellerGRNQCPunch} sellerPIPunchItems={sellerPIPunchItems} materialDetails={materialDetails}/>
                                                </div>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        
    )
}

export default GRN;